import React from 'react';
import { Modal, Box, Paper, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CustomModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  maxWidth = 'sm',    // 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  fullWidth = true,
  disablePadding = false,
  showCloseButton = true,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth: theme => theme.breakpoints.values[maxWidth] || 600,
          padding: 2, // pequeno espaçamento externo para telas pequenas
        }}
      >
        <Paper
          elevation={5}
          sx={{
            borderRadius: 3,
            padding: disablePadding ? 0 : 3,
            position: 'relative',
            outline: 'none',
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          {/* Botão de fechar (opcional) */}
          {showCloseButton && (
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                color: 'grey.500',
              }}
            >
              <CloseIcon />
            </IconButton>
          )}

          {/* Título */}
          {title && (
            <Typography
              id="custom-modal-title"
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ pr: showCloseButton ? 4 : 0 }} // espaço para o botão fechar
            >
              {title}
            </Typography>
          )}

          {/* Subtítulo */}
          {subtitle && (
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ mb: 2 }}
            >
              {subtitle}
            </Typography>
          )}

          {/* Conteúdo principal */}
          <Box sx={{ mt: title || subtitle ? 2 : 0 }}>
            {children}
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};

export default CustomModal;